import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BarLoader from "react-spinners/BarLoader";
import "./refreshpage.css";

const RefreshRandom =()=>
{
    const navigate = useNavigate();

    const  [loading,setLoading] = useState(false);
    const  [load,setLoadingNext] = useState(false);
    const  [list,setLoadingNav] = useState(false);
    useEffect(
        ()=>{
            setLoading(true)
           
            setTimeout(()=>{
                setLoading(false)
                navigate('/abc/');

            },2000)
        },[]
    )
    useEffect(
        ()=>{
            setLoadingNext(true)
           
            setTimeout(()=>{
                setLoadingNext(false)
            },2000)
        },[])
        
    useEffect(
        ()=>{
            setLoadingNav(true)
           
            setTimeout(()=>{
                setLoadingNav(false)
                
            },2000)
        },[]
    )
    return(
        loading ?
        <div>
            <center className="stylingtologo">
            
             
             <BarLoader

                    color={"#0E5C95"}
                      loading={loading}
                     size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                    
                    
             />
             <h1>Analyzing Data</h1>
            
            </center>
            
                 
        </div>
       
       
        :

        <div>
        
     
        </div>
        

    )
}
export default RefreshRandom;